export { default as VerifyEmail } from './VerifyEmail'
